module.exports = __webpack_public_path__ + "img/transactions-fill.0897de6d.svg";